<!-- The height is a custom property rather than an SCSS constant so callers can
     size the editor per context (a blog article wants more room than a charity
     blurb) without a second stylesheet. -->
<!-- The section's colours ride in as custom properties so the PREVIEW panes
     can paint themselves the band the copy will actually sit on (#240). -->
<div [ngStyle]="{
       '--md-editor-height': heightRem + 'rem',
       '--md-preview-bg': previewBg,
       '--md-preview-fg': previewFg
     }" [class.md-autogrow]="autoGrow">
  <!-- EasyMDE replaces this textarea at ngAfterViewInit and supplies its own
       toolbar, preview and side-by-side view. No formControlName: once
       CodeMirror is attached the textarea stops emitting input events, so the
       component mirrors the editor onto the control via ControlValueAccessor. -->
  <textarea #host rows="10" class="inputfield w-full"></textarea>

  <!-- Token autocomplete (#208). Positioned from CodeMirror's own cursor
       coords, so it tracks the caret rather than sitting in a fixed corner.
       mousedown, not click: click fires after blur, by which time the caret
       has moved and the stub we are replacing is gone. -->
  <!-- Colour / alignment menu (#240). mousedown, not click: click fires after
       the editor has blurred, by which time the selection is gone. A press
       outside it closes it (onDocumentMouseDown). -->
  <ul *ngIf="markerMenuOpen" #markerMenu class="md-marker-menu"
      [style.top.px]="markerMenuTop" [style.left.px]="markerMenuLeft">
    <!-- Only offered when the cursor is inside a marker of this kind. -->
    <li *ngIf="markerClearable" class="md-marker-clear"
        (mousedown)="$event.preventDefault(); clearMarkerChoice()">
      <i class="pi pi-times"></i>
      <span>{{ markerMenuKind === 'colour' ? 'Clear colour' : 'Clear alignment' }}</span>
    </li>
    <li *ngFor="let m of markerMenuItems"
        (mousedown)="$event.preventDefault(); applyMarkerChoice(m.value)">
      <span class="md-marker-swatch" [attr.data-marker]="m.value"></span>
      <span>{{ m.label }}</span>
    </li>
  </ul>

  <ul *ngIf="tokenOpen" class="md-token-list" [style.top.px]="tokenTop" [style.left.px]="tokenLeft">
    <li *ngFor="let c of tokenMatches; let i = index"
        [class.is-active]="i === tokenIndex"
        (mousedown)="$event.preventDefault(); acceptToken(c)">
      <span class="md-token-label">{{ c.label }}</span>
      <span class="md-token-preview">{{ c.preview }}</span>
    </li>
  </ul>
</div>
